export const PHONE_DISPLAY = "06 20 37 82 80";
export const PHONE_TEL = "tel:+33620378280";
export const EMAIL = "contact@parebriseparis.fr";
export const EMAIL_MAILTO = "mailto:contact@parebriseparis.fr";
export const WHATSAPP_URL =
    "https://wa.me/33620378280?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20mon%20pare-brise";
export const LOGO_SRC = "/assets/logo.jpeg";

export const NAV_LINKS = [
    { id: "accueil", label: "Accueil" },
    { id: "services", label: "Nos services" },
    { id: "faq", label: "FAQ" },
    { id: "contact", label: "Contact" },
];

export const HERO_BG =
    "https://images.unsplash.com/photo-1581439645268-ea7bbe6bd091?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBibGFjayUyMGNhciUyMG5pZ2h0JTIwY2l0eXxlbnwwfHx8fDE3ODgxNzg2MDF8MA&ixlib=rb-4.1.0&q=85";

export const HERO_VIDEO = "/assets/hero-parebrise-paris.mp4";

export const SERVICE_IMAGES = {
    remplacement: "/assets/service-remplacement.jpg",
    reparation:
        "https://images.unsplash.com/photo-1608259243654-70c070e0f6ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjYXIlMjB3aW5kc2hpZWxkJTIwcmVwYWlyJTIwbWVjaGFuaWN8ZW58MHx8fHwxNzg4MTc4NjAxfDA&ixlib=rb-4.1.0&q=85",
    domicile: "/assets/service-domicile.jpg",
};
